import { FCC } from "@/types/common";
import { TGetCompanyExistsDto, TGetCompanyActiveJobsDto } from "@/api/services/main/company/dtos/get-company.dto";
import { Modal } from "@/components/elements/Modal";
import { Box } from "@mui/system";
import { Stack, Typography, Link } from "@mui/material";
import { secondary, text } from "@/theme/colors";
import { getDynamicRoute } from "@/utils/url";
import { AppRoutes } from "@/routes/config";

type TCompanyDuplicationErrorModalProps = {
  message?: string;
  open: boolean;
  onClose: () => void;
  list: TGetCompanyExistsDto[] | TGetCompanyActiveJobsDto[];
};

export const CompanyDuplicationErrorModal: FCC<TCompanyDuplicationErrorModalProps> = ({ message, open, onClose, list }) => {
  const handleClick = (id: string) => {
    const detailRoute = getDynamicRoute(AppRoutes.companyDetail, { companyId: id });
    if (detailRoute) window.open(detailRoute, "_blank");
  };
  return (
    <Modal isOpen={open} onClose={onClose} title="エラー" labelClose="閉じる" width={500} enableFooter={true} justifyBtnAction="center" hiddenOkBtn>
      <Box mb={2}>
        <Typography variant="body1" sx={{ mb: 2, mt: 1 }}>
          {message}
        </Typography>
        <Stack
          spacing={1.5}
          sx={{
            maxHeight: "500px",
            overflow: "auto",
          }}
        >
          {list.map((item) => (
            <Box
              key={item.id}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: text.primary,
                  lineHeight: 1,
                  flexShrink: 0,
                }}
              >
                ・
              </Typography>
              <Link
                component="button"
                variant="body1"
                onClick={() => handleClick(String(item.id))}
                sx={{
                  textDecoration: "none",
                  color: secondary[80],
                  cursor: "pointer",
                  textAlign: "left",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {item.name}
              </Link>
            </Box>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
};
